import { useState, useCallback } from 'react';

let setGlobalLoading: ((loading: boolean) => void) | null = null;

export function useGlobalLoading() {
    const [loading, setLoading] = useState(false);

    setGlobalLoading = setLoading;

    const showLoading = useCallback(() => setLoading(true), []);
    const hideLoading = useCallback(() => setLoading(false), []);

    return { loading, showLoading, hideLoading };
}

// Utility functions to control loading globally
export function showGlobalLoading() {
    setGlobalLoading?.(true);
}

export function hideGlobalLoading() {
    setGlobalLoading?.(false);
}